import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  orders: [],
  orderItems: [],
  filteredOrderItems: [],
  selectedOrder: null,
  loading: false,
  error: null,
  kpiMetrics: null,
  pagination: {
    current: 1,
    pageSize: 30,
    total: 0
  },
  filters: {
    searchText: '',
    selectedStatus: [],
    selectedDateRange: null,
    selectedSellerAccount: 'all',
    selectedCustomizationStatus: 'all',
    selectedPrinter: 'all',
    selectedFulfillmentStatus: 'all',
    selectedFulfillmentChannel: 'all',
    selectedShipmentStatus: 'all',
    selectedSupporter: 'all',
    selectedCategory: 'all',
    selectedMessageStatus: 'all',
    selectedShipDateDue: 'all',
    selectedDeliveryDateDue: 'all',
    selectedConfirmShipment: 'all',
    selectedUpdatedLastMile: 'all',
    selectedMockupSentAt: 'all',
    selectedTitle: '',
    selectedSellerSku: '',
    selectedEmployeeId: '',
    selectedExcludeTitle: '',
    selectedExcludeSellerSku: '',
  },
};

// Orders slice
const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    setOrderItems: (state, action) => {
      state.orderItems = action.payload;
      state.filteredOrderItems = action.payload;
    },
    setFilteredOrderItems: (state, action) => {
      state.filteredOrderItems = action.payload;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setKpiMetrics: (state, action) => {
      state.kpiMetrics = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        searchText: '',
        selectedStatus: [],
        selectedDateRange: null,
        selectedSellerAccount: 'all',
        selectedCustomizationStatus: 'all',
        selectedPrinter: 'all',
        selectedFulfillmentStatus: 'all',
        selectedFulfillmentChannel: 'all',
        selectedShipmentStatus: 'all',
        selectedSupporter: 'all',
        selectedCategory: 'all',
        selectedMessageStatus: 'all',
        selectedShipDateDue: 'all',
        selectedDeliveryDateDue: 'all',
        selectedConfirmShipment: 'all',
        selectedUpdatedLastMile: 'all',
        selectedMockupSentAt: 'all',
        selectedTitle: '',
        selectedSellerSku: '',
        selectedEmployeeId: '',
        selectedExcludeTitle: '',
        selectedExcludeSellerSku: '',
      };
    },
    updateOrderItem: (state, action) => {
      const { id, field, value } = action.payload;
      
      // Update in orderItems array
      const orderItemIndex = state.orderItems.findIndex(item => item.id === id);
      if (orderItemIndex !== -1) {
        state.orderItems[orderItemIndex][field] = value;
      }
      
      // Update in filteredOrderItems array
      const filteredItemIndex = state.filteredOrderItems.findIndex(item => item.id === id);
      if (filteredItemIndex !== -1) {
        state.filteredOrderItems[filteredItemIndex][field] = value;
      }
    },
  },
});

export const {
  setOrders,
  setOrderItems,
  setFilteredOrderItems,
  setSelectedOrder,
  setLoading,
  setError,
  setKpiMetrics,
  setPagination,
  setFilters,
  clearFilters,
  updateOrderItem,
} = ordersSlice.actions;

export default ordersSlice.reducer;